export const LAST_HOPE_SHOWED_COOKIE_KEY = 'countCallNowPopupShowed';
export const PHONE_SHOWED_STORAGE_KEY = 'newobjectIdsUserOpenedPhoneIn';
export const LIMIT_IN_A_DAY = 2;
export const LAST_HOPE_SHOWED_DELAY = 20000;
